import axios from '@/utils/http.js'
import sys from '@/api/sys/sys.js'
import token from '@/api/token.js'
import user from '@/api/sys/user/user.js'
import role from '@/api/sys/role/role.js'
import permission from '@/api/sys/permission/permission.js'

const api = {
    sys,
    token,
    user,
    role,
    permission,
    get: function (url, params) {
        // console.log('有没有',params);
        return axios.get(url, { params: params })
    },
    post: function (url, form) {
        return axios.post(url, form);
    },
    // 新增delete方法
    delete: function (url, form) {
        return axios.delete(url, form);
    }
}

export default api